module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"option":{"placeholder":"Tulis Nama option di sini"},"add":"Create"}}')
  delete Component.options._Ctor
}
